import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import CookieConsent from "./CookieConsent";
import { trackPageView } from "../lib/analytics";

export default function Layout() {
  const { pathname } = useLocation();

  // Scroll-to-top on route change unless there's a hash.
  useEffect(() => {
    if (window.location.hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  // Fire GA4 page_view on every client-side route change (consent-gated).
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return (
    <>
      <Header />
      <main className="pt-16 md:pt-20" data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
      <CookieConsent />
    </>
  );
}
